module.exports = __webpack_public_path__ + "img/loop.d74bb64a.png";